import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { EasmFindingDetailsDataProviderFactory } from '../factory/EasmFindingDetailsDataProviderFactory';
import { EasmFindingDetailsDataProvider } from '../dataProvider/EasmFindingDetailsDataProvider';
import { CveDetail, FindingDetailsPayload } from '../../findingDetails/findingDetails/types';

export class EasmFindingDetailsRepository extends BaseWebComponentRepository {
  public dataProviderFactory: EasmFindingDetailsDataProviderFactory;
  public dataProvider: EasmFindingDetailsDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new EasmFindingDetailsDataProviderFactory(),
    });
  }

  async getDetailsForFinding(findingId: string): Promise<FindingDetailsPayload> {
    return this.dataProvider.getDetailsForFinding(findingId);
  }

  async getCVEFromStandardIdsForCompany(companyId: string, cveStandardIds: Array<string>): Promise<CveDetail[]> {
    return this.dataProvider.getCVEFromStandardIdsForCompany(companyId, cveStandardIds);
  }
}
